var _path, _path2, _path3, _path4, _circle, _circle2, _circle3, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgOnlineService = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 80,
  height: 80,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeWidth: 2.5,
  d: "M72 70V31H59M8 70V31h13.85"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M33 69H2a5 5 0 0 0 5 5h66a5 5 0 0 0 5-5H47a2 2 0 0 1-2 2H35a2 2 0 0 1-2-2",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeWidth: 2,
  d: "M21 8h38v55H21z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeWidth: 1.5,
  d: "M22 16.25h37"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 25.5,
  cy: 12.5,
  r: 1.5,
  fill: "#000"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 29.5,
  cy: 12.5,
  r: 1.5,
  fill: "#000"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 33.5,
  cy: 12.5,
  r: 1.5,
  fill: "#000"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M42.137 28.065c-.456-.27 0-.678.418-.678.49.049.948.25 1.301.573 0 0-1.18.426-1.72.105m-6.38 5.724c-1.58.408-1.162-2.933.845-5.601a12.3 12.3 0 0 1 3.646-3.536c-.348 3.97-2.807 8.696-4.492 9.137m9.841-10.795a5.33 5.33 0 0 0-3.726.228A4.8 4.8 0 0 0 41.696 21l-1.48.399c.131.84.165 1.692.1 2.54-3.326 1.842-5.858 4.723-7.154 8.14-.778 2.628 1.395 3.518 3.223 2.226 4.514-3.19 5.423-10.453 5.423-10.453.501-.198 1.048-.27 1.587-.21.54.06 1.053.25 1.492.552 1.595 1.328-.476 3.367-.476 3.367a2.46 2.46 0 0 0-1.547-.693c-1.617-.14-2.437 1.73-.293 1.931.568.01 1.133-.08 1.665-.267a3.82 3.82 0 0 1-.131 2.523 4.1 4.1 0 0 1-1.697 1.957c-1.866.79-2.552-.317-2.552-.317a5.5 5.5 0 0 0-.957 1.313 2.74 2.74 0 0 0 1.433.901 2.9 2.9 0 0 0 1.722-.088 4.95 4.95 0 0 0 1.848-1.15 4.56 4.56 0 0 0 1.122-1.798 4.14 4.14 0 0 0-.08-3.625c2.843-1.91 2.425-4.498.638-5.248"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeWidth: 0.5,
  d: "M45.598 22.994a5.33 5.33 0 0 0-3.726.228A4.8 4.8 0 0 0 41.696 21l-1.48.399c.131.84.165 1.692.1 2.54-3.326 1.842-5.858 4.723-7.154 8.14-.778 2.628 1.395 3.518 3.223 2.226 4.514-3.19 5.423-10.453 5.423-10.453.501-.198 1.048-.27 1.587-.21.54.06 1.053.25 1.492.552 1.595 1.328-.476 3.367-.476 3.367a2.46 2.46 0 0 0-1.547-.693c-1.617-.14-2.437 1.73-.293 1.931.568.01 1.133-.08 1.665-.267a3.82 3.82 0 0 1-.131 2.523 4.1 4.1 0 0 1-1.697 1.957c-1.866.79-2.552-.317-2.552-.317a5.5 5.5 0 0 0-.957 1.313 2.74 2.74 0 0 0 1.433.901 2.9 2.9 0 0 0 1.722-.088 4.95 4.95 0 0 0 1.848-1.15 4.6 4.6 0 0 0 1.122-1.798 4.14 4.14 0 0 0-.08-3.625c2.843-1.91 2.425-4.498.638-5.248m-3.445 5.065c-.456-.27 0-.678.418-.678.49.049.948.25 1.301.573 0 0-1.18.426-1.72.105Zm-6.38 5.724c-1.58.408-1.162-2.933.845-5.601a12.3 12.3 0 0 1 3.646-3.536c-.348 3.97-2.807 8.696-4.492 9.137Z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeWidth: 2,
  d: "M30 41h20M30 48h20M30 55h20"
})));
export { SvgOnlineService as ReactComponent };
export default "/_next/static/images/online-service.svg";